import { actions } from "./action";
import { mutations } from "./mutations";
import { getters, state } from "./state";

export default {
  state,
  getters,
  actions,
  mutations,
};
